/**
 * Whether an HTMLImageElement is safe to pass to CanvasRenderingContext2D.drawImage.
 * Broken images (e.g. unsupported formats like EMF) report complete=true with naturalWidth=0;
 * drawImage throws InvalidStateError in that state.
 */
export function getIsDrawableHtmlImage(
  image: Pick<HTMLImageElement, 'complete' | 'naturalWidth'>
): boolean {
  return image.complete && image.naturalWidth > 0;
}
